import React from 'react';
import HeroSection from '../../components/User/Home/HeroSection';
import AboutSection from '../../components/User/Home/AboutSection';
import ContactSection from '../../components/User/Home/ContactSection';
// import TestimonialSection from '../../components/User/Home/Testimonialsection';
import StatsSection from '../../components/User/Home/Statssection';
import IntegrationStack from '../../components/User/Home/IntegrationStack';
import BlogSection from '../../components/User/Home/BlogSection';

const Home = () => (
    <div>
        <HeroSection/>
        <AboutSection/>
        <ContactSection/>
        <IntegrationStack/>
        <StatsSection/>
        <BlogSection/>
    </div>
);

export default Home;
